import React, { useState } from "react";
import { Link } from "react-router-dom";

const cardStyle: React.CSSProperties = {
  background: "#ffffff",
  border: "1px solid #e5e7eb",
  borderRadius: 16,
  padding: "1rem",
};

const gridStyle: React.CSSProperties = {
  display: "grid",
  gap: "1rem",
  gridTemplateColumns: "repeat(auto-fit, minmax(220px, 1fr))",
};

const fieldWrapStyle: React.CSSProperties = {
  display: "grid",
  gap: "0.45rem",
};

const labelStyle: React.CSSProperties = {
  fontSize: "0.92rem",
  fontWeight: 600,
  color: "#334155",
};

const inputStyle: React.CSSProperties = {
  width: "100%",
  border: "1px solid #d1d5db",
  borderRadius: 12,
  padding: "0.85rem 0.95rem",
  fontSize: "0.98rem",
  color: "#0f172a",
  background: "#ffffff",
};

const textareaStyle: React.CSSProperties = {
  ...inputStyle,
  minHeight: 110,
  resize: "vertical" as const,
};

const primaryButtonStyle: React.CSSProperties = {
  border: "none",
  borderRadius: 12,
  background: "#111827",
  color: "#fff",
  padding: "0.85rem 1rem",
  fontWeight: 700,
  cursor: "pointer",
};

const secondaryButtonStyle: React.CSSProperties = {
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  textDecoration: "none",
  border: "1px solid #d1d5db",
  borderRadius: 12,
  background: "#fff",
  color: "#111827",
  padding: "0.85rem 1rem",
  fontWeight: 700,
};

export default function ProviderNewStylistPage() {
  const [savedAt, setSavedAt] = useState<string | null>(null);
  const [form, setForm] = useState({
    fullName: "",
    roleTitle: "",
    experienceYears: "1",
    specialties: "",
    availableServices: "",
    profilePhotoUrl: "",
    verificationStatus: "PENDING",
    bio: "",
  });

  const updateField =
    (field: keyof typeof form) =>
    (
      event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>,
    ) => {
      setForm((current) => ({
        ...current,
        [field]: event.target.value,
      }));
    };

  const handleSave = (event: React.FormEvent) => {
    event.preventDefault();
    setSavedAt(new Date().toLocaleTimeString());
  };

  return (
    <div style={{ display: "grid", gap: "1rem" }}>
      <section style={cardStyle}>
        <h2 style={{ margin: 0, color: "#0f172a" }}>New stylist</h2>
        <p style={{ margin: "0.5rem 0 0", color: "#475569", lineHeight: 1.7 }}>
          Create a provider-side team member so review teams can assess staffing readiness.
        </p>
      </section>

      <form onSubmit={handleSave} style={{ display: "grid", gap: "1rem" }}>
        <section style={cardStyle}>
          <div style={gridStyle}>
            <div style={fieldWrapStyle}>
              <label style={labelStyle}>Full name</label>
              <input
                style={inputStyle}
                value={form.fullName}
                onChange={updateField("fullName")}
                placeholder="Riya Kaur"
              />
            </div>

            <div style={fieldWrapStyle}>
              <label style={labelStyle}>Role title</label>
              <input
                style={inputStyle}
                value={form.roleTitle}
                onChange={updateField("roleTitle")}
                placeholder="Senior stylist"
              />
            </div>

            <div style={fieldWrapStyle}>
              <label style={labelStyle}>Experience years</label>
              <input
                style={inputStyle}
                type="number"
                min={0}
                value={form.experienceYears}
                onChange={updateField("experienceYears")}
              />
            </div>

            <div style={fieldWrapStyle}>
              <label style={labelStyle}>Verification status</label>
              <select
                style={inputStyle}
                value={form.verificationStatus}
                onChange={updateField("verificationStatus")}
              >
                <option value="PENDING">PENDING</option>
                <option value="APPROVED">APPROVED</option>
                <option value="REJECTED">REJECTED</option>
              </select>
            </div>
          </div>
        </section>

        <section style={cardStyle}>
          <div style={{ display: "grid", gap: "1rem" }}>
            <div style={fieldWrapStyle}>
              <label style={labelStyle}>Specialties</label>
              <input
                style={inputStyle}
                value={form.specialties}
                onChange={updateField("specialties")}
                placeholder="Bridal makeup, haircut styling, beard grooming"
              />
            </div>

            <div style={fieldWrapStyle}>
              <label style={labelStyle}>Available services</label>
              <input
                style={inputStyle}
                value={form.availableServices}
                onChange={updateField("availableServices")}
                placeholder="Haircut, beard trim, cleanup facial"
              />
            </div>

            <div style={fieldWrapStyle}>
              <label style={labelStyle}>Profile photo URL</label>
              <input
                style={inputStyle}
                value={form.profilePhotoUrl}
                onChange={updateField("profilePhotoUrl")}
                placeholder="https://..."
              />
            </div>

            <div style={fieldWrapStyle}>
              <label style={labelStyle}>Short bio</label>
              <textarea
                style={textareaStyle}
                value={form.bio}
                onChange={updateField("bio")}
                placeholder="Short operational summary for internal and provider-side use."
              />
            </div>
          </div>
        </section>

        <section style={cardStyle}>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              gap: "0.75rem",
              flexWrap: "wrap",
              alignItems: "center",
            }}
          >
            <div style={{ color: "#475569" }}>
              {savedAt ? `Stylist draft saved locally at ${savedAt}` : "No local save yet"}
            </div>

            <div style={{ display: "flex", gap: "0.75rem", flexWrap: "wrap" }}>
              <button type="submit" style={primaryButtonStyle}>
                Save stylist
              </button>
              <Link to="/provider/dashboard/stylists" style={secondaryButtonStyle}>
                Back to stylists
              </Link>
              <Link to="/provider/onboarding/review" style={secondaryButtonStyle}>
                Return to review
              </Link>
            </div>
          </div>
        </section>
      </form>
    </div>
  );
}